import type { FC } from "react";

export const LookupIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="#EEF0F2" />
    <path
      d="M9.50076 6.99447C9.50076 7.8216 8.82986 8.49205 8.00221 8.49205C7.17456 8.49205 6.50366 7.8216 6.50366 6.99447C6.50366 6.16737 7.17456 5.49687 8.00221 5.49687C8.82986 5.49687 9.50076 6.16737 9.50076 6.99447Z"
      stroke="url(#paint0_linear_10523_40696)"
      strokeLinecap="round"
    />
    <path
      d="M7.99731 10.4888H8.00181"
      stroke="url(#paint1_linear_10523_40696)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2481 3.00087C12.1648 3.45015 11.7486 4.37866 10.7495 4.49846"
      stroke="url(#paint2_linear_10523_40696)"
      strokeLinecap="round"
    />
    <path
      d="M3.75635 3.00087C3.8396 3.45015 4.25586 4.37866 5.25489 4.49846"
      stroke="url(#paint3_linear_10523_40696)"
      strokeLinecap="round"
    />
    <path
      d="M6.42016 3.84674C4.79322 4.57097 4.22212 6.31201 4.26052 7.2329C3.69901 7.1945 3.01141 7.2574 3.00084 7.97545C2.99027 8.6935 3.7326 8.82045 4.26052 8.7341V11.9379C4.26936 12.2031 4.29318 12.5501 4.56767 12.6718C5.20597 12.9547 5.74348 12.0962 6.32751 12.1356C6.78154 12.1662 7.43876 13.0453 8.01666 12.9972C8.68601 12.9415 9.20116 12.1383 9.71296 12.1383C10.3199 12.1383 10.4262 12.6387 11.1571 12.7183C11.7022 12.7778 11.7576 12.258 11.7576 11.9782V8.7401C12.7022 8.85725 13.0766 8.43875 12.9863 7.8493C12.8798 7.1537 12.063 7.20335 11.7379 7.2478C11.7885 6.73056 11.5553 6.07775 11.4546 5.82187C11.3062 5.36634 10.6963 4.28953 9.38611 3.75561C8.07586 3.22169 6.85689 3.61653 6.42016 3.84674Z"
      stroke="url(#paint4_linear_10523_40696)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10523_40696"
        x1="9.50076"
        y1="5.49687"
        x2="6.17158"
        y2="5.92807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#3D7276" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10523_40696"
        x1="8.00181"
        y1="10.4888"
        x2="7.99673"
        y2="10.4889"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#3D7276" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10523_40696"
        x1="12.2481"
        y1="3.00087"
        x2="10.5835"
        y2="3.21647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#3D7276" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10523_40696"
        x1="5.25489"
        y1="3.00087"
        x2="3.5903"
        y2="3.21646"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#3D7276" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10523_40696"
        x1="12.9994"
        y1="3.489"
        x2="1.91187"
        y2="4.99784"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#3D7276" />
      </linearGradient>
    </defs>
  </svg>
);
